import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import style from './style.module.css';
import css from "classnames";



const ContactForm = () => {
    const [alertShow, setAlertShow] = useState(false);
    const [successShow, setSuccessShow] = useState(false);

    function Alert({ children, type, message }) {
        const [isShow, setIsShow] = useState(true);

        const renderElAlert = function () {
            return React.cloneElement(children);
        };

        const handleClose = (e) => {
            e.preventDefault();
            setAlertShow(false);
            setIsShow(false);
            setSuccessShow(false)
            setFormSent(false)
        };

        console.log(alertShow)

        return (
            <div className={css(style.alert, style[type], !isShow && style.hide)}>
                <span className={style.closebtn} onClick={handleClose}>
                    &times;
                </span>
                {children ? renderElAlert() : message}
            </div>
        );
    }
    const form = useRef();
    const [formSent, setFormSent] = useState(false);

    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [company, setCompany] = useState('');

    function EmptyFields() {
        setName('');
        setTitle('');
        setCompany('');
        setEmail('');
        setPhone('');
    }

    const sendEmail = (e) => {
        e.preventDefault();

        if (name && title && company && email && phone) {

            emailjs.sendForm('service_0l1vi0k', 'template_mo3fc5q', form.current, 'LXYnlMRSZPJuWCYq8')
                .then((result) => {
                    console.log(result.text);
                    setFormSent(true);
                    setAlertShow(false)
                    EmptyFields();
                }, (error) => {
                    console.log(error.text);
                });

        } else {
            setAlertShow(true);
        }
    };

    return (
        <>
            <div className='formContainer'>

                <h3 className='formTitle'>Inscription à l'atelier</h3>
                <div className='formSubTitle'>(date limite : vendredi 30 septembre à 17h)</div>
                <div className='contactForm'>
                    <form ref={form} onSubmit={sendEmail}>
                        <div className='formInput'>
                            <input type="text" name="user_name" placeholder='NOM COMPLET &#x2739;' value={name} onChange={e => setName(e.target.value)} />
                        </div>
                        <div className='formInput'>
                            <input type="text" name="user_title" placeholder='TITRE / FONCTION &#x2739;' value={title} onChange={e => setTitle(e.target.value)} />
                        </div>
                        <div className='formInput'>
                            <input type="text" name="user_company" placeholder='ENTREPRISE / CSMO &#x2739;' value={company} onChange={e => setCompany(e.target.value)} />
                        </div>
                        <div className='formInput'>
                            <input type="email" name="user_email" placeholder='COURRIEL &#x2739;' value={email} onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div className='formInput'>
                            <input type="tel" name='user_tel' placeholder='TÉLÉPHONE / CELLULAIRE &#x2739;' value={phone} onChange={e => setPhone(e.target.value)} />
                        </div>
                        <div className='necessaryMsg'>
                            &#x2739; Champ obligatoire
                        </div>
                        <div className={alertShow === true ? 'showMessage' : 'hideMessage'}>
                            <Alert type="error" message="Merci de remplir tous les champs." />
                        </div>
                        <div className={formSent === true ? 'showMessage' : 'hideMessage'}>
                            <Alert type="success">
                                <p>Votre message a été envoyé.</p>
                            </Alert>
                        </div>
                        <div className='formButton'>
                            <input type="submit" value="Envoyer" />
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default ContactForm